module.exports = __webpack_public_path__ + "static/media/logo-uerre-blanco.0b68b8f8.png";